let form = {
  "labels": {
    "title": "Titel",
    "description": "Beschreibung",
    "phone": "Rufnummer",
    "email": "E-Mail Adresse",
    "address": "Adresse",
    "product": "Produkt",
    "product_title": "Titel",
    "quantity": "Menge",
    "price": "Preis",
    "price_type": "Gerät",
    "price_per_unit": "Preis pro Einheit",
    "vat_option": "UMSATZSTEUER",
    "total": "Gesamt",
    "name": "Name",
    "first_and_last_name": "Vor- und Nachname",
    "honorific": "Höflichkeit",
    "phone_number": "Rufnummer",
    "address_line_1": "Adresszeile 1",
    "address_line_2": "Adresszeile 2",
    "postal_code": "Postleitzahl",
    "city": "Stadt",
    "country": "Land",
    "comments": "Kommentare",
    "is_professional": "Professioneller Kunde",
    "vat_number": "Umsatzsteueridentifikationsnummer",
    "vat_option_id": "UMSATZSTEUER",
    "default_vat_option_id": "Standard-Mehrwertsteuer",
    "category_id": "Kategorie",
    "price_type_id": "Gerät",
    "percentage": "Prozentsatz",
    "payment_date": "Verfallsdatum",
    "payment_communication": "Zahlungsanweisung",
    "valid_until": "Gültigkeitsdatum",
    "paid_at": "Datum der Zahlung",
    "discount": "Rabatt",
    "subject": "Thema",
    "email_subject": "Betreff der E-Mail",
    "email_text": "Text der E-Mail",
    "email_to": "Empfänger",
    "email_copy": "Senden Sie mir eine Kopie per E-Mail",
    "status": "Status",
    "amount": "Betrag",
    "company_name": "Name der Firma",
    "company_email": "E-Mail Adresse",
    "company_phone_number": "Rufnummer",
    "company_vat": "Umsatzsteueridentifikationsnummer",
    "company_vat_number": "Umsatzsteueridentifikationsnummer",
    "company_address_line_1": "Adresszeile 1",
    "company_address_line_2": "Adresszeile 2",
    "company_postal_code": "Postleitzahl",
    "company_city": "Stadt",
    "company_country": "Land",
    "company_logo": "Logo",
    "client_id": "Kunde",
    "client_name": "Name des Kunden",
    "client_email": "E-Mail Adresse",
    "client_phone_number": "Rufnummer",
    "client_vat_number": "Umsatzsteueridentifikationsnummer",
    "client_address_line_1": "Adresszeile 1",
    "client_address_line_2": "Adresszeile 2",
    "client_postal_code": "Postleitzahl",
    "client_city": "Stadt",
    "client_country": "Land",
    "client_reminder_1_enabled": "Aktivieren Sie die erste Rückrufebene für diesen Kunden",
    "client_reminder_2_enabled": "Aktivieren Sie die zweite Rückrufebene für diesen Client",
    "client_reminder_3_enabled": "Aktivieren Sie die dritte Ebene des Rückrufs für diesen Client",
    "invoice_title": "Referenz",
    "invoice_files": "Verwandte Dateien",
    "invoice_number_prefix": "Präfix",
    "invoice_number_prefix_custom": "Benutzerdefiniertes Präfix",
    "current_year": "Jahr",
    "invoice_number_format": "Format",
    "invoice_number_demo": "Beispiel",
    "invoice_number_starts_at": "Beginn der Nummerierung",
    "invoice_number_starts_at_year": "Übertragen Sie diese Nummerierung auf das Jahr",
    "invoice_number_starts_at_month": "Wenden Sie diese Nummerierung auf den Monat an",
    "invoice_send_email_subject": "Betreff der E-Mail",
    "invoice_send_email_text": "Text der E-Mail",
    "invoice_send_email_copy": "Senden Sie mir eine Kopie per E-Mail",
    "invoice_payment_delay": "Standard-Zahlungsbedingung",
    "invoice_payment_delay_type": null,
    "invoice_iban_number": "IBAN",
    "invoice_bic": "BIC",
    "invoice_payment_communication_type": "Art der Kommunikation",
    "invoice_number": "Rechnungsnummer",
    "structured_communication": "Strukturierte Kommunikation",
    "invoice_payment_communication_type_custom": "Personalisierte Kommunikation",
    "invoice_payment_communication": "Standard-Zahlungsanweisung",
    "invoice_extra_pdf": "PDF",
    "invoice_display_custom_start": "Ändern Sie den Beginn der Nummerierung",
    "quote_decline_reason": "Grund für die Ablehnung",
    "quote_validity_delay": "Standard-Gültigkeitsdauer",
    "quote_conditions": "Bedingungen des Angebots",
    "reminder_enabled": "Aktivieren Sie diese Erinnerungsstufe",
    "reminder_value": "Tage nach Fälligkeit",
    "reminder_email_subject": "Betreff der E-Mail",
    "reminder_email_text": "Text der E-Mail",
    "reminder_email_copy": "Senden Sie mir eine Kopie dieser E-Mail",
    "display_primary_color": "Hauptfarbe",
    "display_secondary_color": "Sekundärfarbe",
    "card_number": "Kartennummer",
    "card_expiry": "Verfallsdatum",
    "card_cvv": "CVV",
    "cocontractor": "VAT Mitauftragnehmer",
    "next_invoice_number": "Rechnungsnummer",
    "next_quote_number": "Zitat Nummer",
    "next_credit_note_number": "Gutschriftsnummer",
    "record_payment_predefined_title": "Titel",
    "record_payment_custom_title": "Titel",
    "invoice_template": "Musterdokument",
    "image_uploader_button": "Ein Bild hochladen...",
    "image_uploader_button_multiple": "Bilder hochladen...",
    "image_uploader_button_more": "Lassen Sie ein weiteres Bild fallen...",
    "image_uploader_button_more_multiple": "Andere Bilder einreichen...",
    "image_uploader_button_replace": "Ablegen, um das Bild zu ersetzen...",
    "image_uploader_button_replace_multiple": "Ablegen, um Bilder zu ersetzen...",
    contacts: { 
      title: "Kontakt",
      types: "Kontaktart",
      name: "Name des Kontakts"
    }
  },
  "placeholders": null,
  "messages": {
    "image_uploader_confirm_image_replacement": "Sind Sie sicher, dass Sie das aktuelle Bild ersetzen wollen?",
    "image_uploader_wrong_image_type": "Das Dateiformat ist nicht als Bild gültig."
  },
  "buttons": {
    "create": "erstellen.",
    "edit": "Bearbeiten"
  },
  "variables": {
    "invoicenumber": "Rechnungsnummer",
    "quotenumber": "Zitat Nummer",
    "creditnotenumber": "Gutschriftsnummer",
    "communication": "Kommunikation",
    "invoiceamount": "Betrag der Rechnung",
    "quoteamount": "Betrag der Schätzung",
    "creditnoteamount": "Betrag der Gutschrift",
    "invoiceremainingamount": "Verbleibender Saldo der Rechnung",
    "creditnoteremainingamount": "Verbleibender Saldo der Gutschrift",
    "iban": "IBAN",
    "bic": "BIC",
    "invoicedate": "Datum der Rechnung",
    "quotedate": "Datum des Angebots",
    "creditnotedate": "Datum der Gutschrift",
    "duedate": "Verfallsdatum",
    "validitydate": "Gültigkeitsdatum",
    "companyname": "Unternehmen"
  },
  "options": {
    "invoice_number_prefix": {
      "none": "Kein Präfix",
      "custom": "Benutzerdefiniertes Präfix",
      "year": "Laufendes Jahr",
      "year2": "Aktuelles Jahr (letzte zwei Ziffern)"
    },
    "invoice_number_format": {
      "1": "Eine Figur",
      "2": "Zwei Figuren",
      "3": "Drei Figuren",
      "4": "Vier Zahlen",
      "5": "Fünf Figuren"
    },
    "invoice_number_starts_at_month": {
      "1": "Januar",
      "2": "Februar",
      "3": "März",
      "4": "April",
      "5": "Mai",
      "6": "Juni",
      "7": "Juli",
      "8": "August",
      "9": "September",
      "10": "Oktober",
      "11": "November",
      "12": "Dezember",
      "none": "Verwenden Sie keinen benutzerdefinierten Start pro Monat"
    },
    "invoice_payment_delay_type": {
      "sent": "Tage bis zum Rechnungsdatum",
      "month": "Monatsende Tage"
    },
    "invoice_payment_communication_type": {
      "invoice_number": "Rechnungsnummer",
      "structured_communication": "Strukturierte Kommunikation",
      "custom": "Personalisiert"
    },
    "quote_validity_delay_type": {
      "sent": "Tage Angebotsdatum"
    },
    "record_payment_title": {
      "total_payment": "Zahlung des Restbetrags",
      "down_payment": "Vorauszahlung",
      "partial_payment": "Teilweise Zahlung",
      "other": "Andere"
    },
    "invoice_template": {
      "default": "Klassisch",
      "tiny": "Winzig",
      "condensed": "Kondensiert",
      "flat-out": "Flach aus"
    }
  },
  "helpers": {
    "cocontractor": "Zeigt \"* Reverse Charge\" auf Dokumenten an, die einen oder mehrere Artikel mit diesem Mehrwertsteuersatz enthalten."
  }
};

form.placeholders = form.labels;
form.placeholders.select = 'Wählen Sie eine Option';

export default form;